
import { groupBy, mapValues, values, cloneDeep } from 'lodash';
import {
    CRITERIA_HEADER_DETAILS,
    SEARCH_CRITERIA_CONFIG
} from './constants.js';
export const getClonedObject = inputObject => inputObject ? cloneDeep(inputObject) : inputObject;

export const groupByMultipleProperties = (collection, keys) => {
    if (!keys.length) {
        return collection;
    }
    const first = keys[0];
    const rest = keys.slice(1);
    return mapValues(groupBy(collection, first), eachValue => {
        return { [first]: eachValue[0][first], subRows: values(groupByMultipleProperties(eachValue, rest)) };
    });
};
const calculateGroup = (item) => {
    let name = '';
    SEARCH_CRITERIA_CONFIG.find(list => {
        ((list.categeryName !== 'Table' && list.categeryName !== 'Products') && list.categoryDetails.find(subList => {
            if (subList.keyCode.toLowerCase() === item)
                name = list.categeryName;
        }))
        // return list.categeryName;
    });
    return name;
    // console.log(name,'name')

}

export const calculateHeader = (data) => {
    return (Object.keys(data)).map((item) => {
        return { key: item, width: 0, groupName: calculateGroup(item), isAscending: false, isDecending: false, isDefault: true, filterValue: '', isFilterOpen: false, isShowFilterControls: false, title: CRITERIA_HEADER_DETAILS.find(list => list.KEY === item).VALUE, isFilterApply: false };
    });
}
export const calculateJoinData = (primary, secondary) => {
    const result = secondary.map((list, index) => {
        return { ...primary[index], ...list }
    });
    return result;
};
export const calculateParsingData = (defaultData) => {
    let mergedSecondaryTable = [];
    let table = [];
    let obj = {};
    defaultData.map((list, index) => {
        if (index === 0) {
            table.push({ title: list.categoryTitle, count: Object.keys(list.data[0]).length, sepration: Object.keys(list.data[0]).length, keys: Object.keys(list.data[0]) });
        }
        else {
            table.push({ title: list.categoryTitle, count: table[index - 1].count + Object.keys(list.data[0]).length, sepration: Object.keys(list.data[0]).length, keys: Object.keys(list.data[0]) });
        }
        list.data.map((subList, subIndex) => {
            mergedSecondaryTable[subIndex] = { ...mergedSecondaryTable[subIndex], ...subList }
            if (index === 0 && subIndex === 0) {
                obj = { ...subList }
            } else if (subIndex === 0) {
                obj = { ...obj, ...subList };
            }
        })
    });
    return { tableTitle: table, tableData: obj, mergedSecondaryTable: mergedSecondaryTable }
}
export const calculateSeprationTableCaption = (totalList) => {
    // console.log(totalList,'calculateSeprationTableCaption')
    let startingSepration = undefined;
    totalList.map((list, index) => {
        if (list.key.indexOf(' ') >= 0) {
            if (!startingSepration)
                startingSepration = index;
        }
    });
    return startingSepration;
};
export const generationgTableObjects = ((totalList) => {
    //  console.log(totalList,'generationgTableObjects')
    let primaryCollection = [];
    let secondaryCollection = [];
    let fullCollection = [];
    totalList.map((list) => {
        if (!list.id)
            list.id = Math.random();
        const { org, des, cxr, fbc, tar, ft, rtg, con, id, isSelect, selectedField, selectedColumn, ...secondary } = list;
        const primary = { org, des, cxr, fbc, tar, ft, rtg, con, id, isSelect, selectedField, selectedColumn };
        const secondaryTable = { selectedColumn, selectedField, isSelect, id, cxr, ...secondary }

        primaryCollection.push(primary);
        secondaryCollection.push(secondaryTable);
        fullCollection.push(list);
    });
    return { primaryCollection, secondaryCollection, fullCollection };
});

export const calculateResultDetails = (result, joinHeaders) => {
    // console.log(result, joinHeaders, 'calculateResultDetails')
    joinHeaders.map((menuList) => {
        const uniqueResult = [... new Set(result.map(list => (list[menuList.key] || list[menuList.key] === 0) ? list[menuList.key].toString() : ''))];
        uniqueResult.sort();
        // const finalFilterResult = uniqueResult.filter(item => item != '');
        const response = uniqueResult.map((item) => {
            return {
                key: item,
                value: true
            };
        });
        menuList.filterUniqueValues = response.length > 0 ? response : [];
        menuList.defaultFilterUniqueValues = response.length > 0 ? [...response] : [];
    });
    return joinHeaders;
};
